import React from "react"
import PropTypes from "prop-types"
import RaisedButton from "material-ui/RaisedButton"

import TextField from "material-ui/TextField"
import FlatButton from "material-ui/FlatButton"
import VerifyField from "../../../../components/misc/VerifyField"
import StateSelectField from "../../../../components/misc/StateSelectField"

const i9Actions = require("../../../../actions/I9Actions")
const propTypes = {
    i9: PropTypes.object,
    onValueChange: PropTypes.func
}

export default class I9Address extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            i9: null
        }
        this.onStreet1Change = this.onStreet1Change.bind(this)
        this.onStreet2Change = this.onStreet2Change.bind(this)
        this.onCityChange = this.onCityChange.bind(this)
        this.onStateChange = this.onStateChange.bind(this)
        this.onZipChange = this.onZipChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.i9) {
            this.setState({
                i9: nextProps.i9
            })
        }
    }

    getStreet1() {
        return this.state.i9 ? this.state.i9.Employee_StreetNumberAndName : ""
    }

    getStreet1Hint() {
        if (this.state.i9) {
            if (this.state.i9.UserDataHint) {
                return this.state.i9.UserDataHint.Street1
            }
        }

        return ""
    }

    getAppartmentNumber() {
        return this.state.i9 ? this.state.i9.Employee_AppartmentNumber : ""
    }

    getAppartmentNumberHint() {
        if (this.state.i9) {
            if (this.state.i9.UserDataHint) {
                return this.state.i9.UserDataHint.Street2
            }
        }

        return ""
    }

    getCity() {
        return this.state.i9 ? this.state.i9.Employee_CityAndTown : ""
    }

    getCityHint() {
        if (this.state.i9) {
            if (this.state.i9.UserDataHint) {
                return this.state.i9.UserDataHint.City
            }
        }

        return ""
    }

    getState() {
        return this.state.i9 ? this.state.i9.Employee_State : ""
    }

    getStateHint() {
        if (this.state.i9) {
            if (this.state.i9.UserDataHint) {
                return this.state.i9.UserDataHint.State
            }
        }

        return ""
    }

    getZip() {
        return this.state.i9 ? this.state.i9.Employee_ZipCode : ""
    }

    getZipHint() {
        if (this.state.i9) {
            if (this.state.i9.UserDataHint) {
                return this.state.i9.UserDataHint.Zipcode
            }
        }

        return ""
    }

    onStreet1Change(value) {
        this.state.i9.Employee_StreetNumberAndName = value
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_StreetNumberAndName: value
        })
    }

    onStreet2Change(value) {
        this.state.i9.Employee_AppartmentNumber = value
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_AppartmentNumber: value
        })
    }

    onCityChange(value) {
        this.state.i9.Employee_CityAndTown = value
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_CityAndTown: value
        })
    }

    onStateChange(value) {
        this.state.i9.Employee_State = value
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_State: value
        })
    }

    onZipChange(value) {
        this.state.i9.Employee_ZipCode = value
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_ZipCode: value
        })
    }

    updateI9() {
        if (this.props.onValueChange) {
            this.props.onValueChange(this.state.i9)
        }
    }

    validate(i9) {
        if (!this.state.i9) {
            return false
        }

        if (
            !this.state.i9.Employee_StreetNumberAndName ||
            this.state.i9.Employee_StreetNumberAndName.length === 0 ||
            !this.state.i9.Employee_CityAndTown ||
            this.state.i9.Employee_CityAndTown.length === 0 ||
            !this.state.i9.Employee_ZipCode ||
            this.state.i9.Employee_ZipCode.length < 5
        ) {
            return false
        } else {
            return true
        }
    }

    render() {
        return (
            <div className="I9Address">
                <b>Address Information</b>
                <VerifyField
                    id="street1"
                    floatingLabelText="Address (Street Number and Name)"
                    value={this.getStreet1()}
                    onValueChange={this.onStreet1Change}
                    hintValue={this.getStreet1Hint()}
                    confirmQuestion={"Is <b>{0}</b> your home street address?"}
                    innerStyle={{ marginTop: 20 }}
                    style={{ width: "100%" }}
                />
                <VerifyField
                    id="street2"
                    floatingLabelText="Apt. Number"
                    value={this.getAppartmentNumber()}
                    hintValue={this.getAppartmentNumberHint()}
                    onValueChange={this.onStreet2Change}
                    confirmQuestion={"Is <b>{0}</b> your apt./house number?"}
                    innerStyle={{ marginTop: 20 }}
                    style={{ width: "100%" }}
                />
                <VerifyField
                    id="cityTown"
                    floatingLabelText="City or Town"
                    value={this.getCity()}
                    hintValue={this.getCityHint()}
                    onValueChange={this.onCityChange}
                    confirmQuestion={"Is <b>{0}</b> your home city or town?"}
                    innerStyle={{ marginTop: 20 }}
                    style={{ width: "100%" }}
                />

                <VerifyField
                    id="state"
                    floatingLabelText="State"
                    type="StateSelectField"
                    value={this.getState()}
                    hintValue={this.getStateHint()}
                    onValueChange={this.onStateChange}
                    confirmQuestion={"Is <b>{0}</b> your home state?"}
                    innerStyle={{ marginTop: 20 }}
                    style={{ width: "100%" }}
                />

                <VerifyField
                    id="zipCode"
                    floatingLabelText="Zip Code"
                    value={this.getZip()}
                    hintValue={this.getZipHint()}
                    onValueChange={this.onZipChange}
                    confirmQuestion={"Is <b>{0}</b> your home postal code?"}
                    innerStyle={{ marginTop: 20 }}
                    style={{ width: "100%" }}
                />
            </div>
        )
    }
}

I9Address.propTypes = propTypes
